<template>
  <div>
    <v-layout row wrap v-for="(item, index) in pendencias" :key="index">
      <v-flex xs12 v-if="mostraTitulo">
        <p class="categoria">{{ item.categoria }}</p>
      </v-flex>

      <v-flex
        :class="classColuna"
        v-for="(anexo, index) in item.listagem"
        :key="index"
      >
        <v-layout row wrap mr-4 v-if="mostraDescricao">
          <v-flex xs12>
            <div class="inline">
              <p
                class="anexo-title"
                :class="
                  (!anexo.arquivos || !anexo.arquivos.length) &&
                  anexo.hasError &&
                  anexo.obrigatorio
                    ? 'has-error-text'
                    : ''
                "
                v-if="mostraDescricao"
              >
                {{
                  anexo.obrigatorio
                    ? anexo.nome + " (obrigatório)"
                    : anexo.nome + " (opcional)"
                }}
              </p>

              <v-tooltip
                class="pull-right"
                slot="append"
                bottom
                v-if="anexo.descricao"
                max-width="300"
              >
                <v-icon
                  :class="
                    (!anexo.arquivos || !anexo.arquivos.length) &&
                    anexo.hasError &&
                    anexo.obrigatorio
                      ? 'has-error-text pull-right'
                      : 'pull-right'
                  "
                  slot="activator"
                  >info</v-icon
                >
                <span>{{ anexo.descricao }}</span>
              </v-tooltip>
            </div>
          </v-flex>
        </v-layout>

        <documento-upload
          :multiplo="anexo.multiplo"
          :id-documento="anexo.id"
          :arquivos="anexo.arquivos"
          :urlModelo="anexo.url_documento_modelo"
          :class="
            (!anexo.arquivos || !anexo.arquivos.length) &&
            anexo.hasError &&
            anexo.obrigatorio
              ? 'has-error'
              : ''
          "
          @select="handleSelectedFile"
          class="anexo-list"
        ></documento-upload>
        <p
          mt-2
          class="has-error-text"
          v-if="
            (!anexo.arquivos || !anexo.arquivos.length) &&
            anexo.hasError &&
            anexo.obrigatorio
          "
        >
          Campo obrigatório
        </p>
      </v-flex>
    </v-layout>
  </div>
</template>

<script lang="js">
import { eventBus } from "../main";

export default {
  name: "AnexoListComponent",
  data() {
    return { pendencias: [] };
  },
  props: [
    "documentosSolicitados",
    "classColuna",
    "mostraTitulo",
    "mostraDescricao",
    "isCartaNomeacao",
  ],
  methods: {
    handleSelectedFile(data) {
      this.pendencias.forEach((categoria) => {
        categoria.listagem.forEach((item) => {
          if (item.id == data.idDocumento) item.arquivos = data.arquivos;
        });
      });

      this.$forceUpdate();
      this.$emit("send", this.pendencias);
      if (!this.isCartaNomeacao) this.validaAnexos(data);
    },

    setModelAnexos() {
      let model = [];

      if (this.pendencias && this.pendencias.length)
        this.pendencias.forEach((categoria) => {
          categoria.listagem.forEach((element) => {
            if (element.arquivos && element.arquivos.length) {
              var arquivos = [];
              element.arquivos.forEach((arquivo) => {
                arquivos.push({
                  nome_em_disco: arquivo.nome,
                  arquivo: arquivo.arquivo,
                });
              });

              model.push({
                id: element.id,
                nome: element.nome,
                arquivos: arquivos,
              });
            }
          });
        });
      else model = null;

      this.$emit("setDocumentosModel", model);
    },

    validaAnexos(data) {
      this.pendencias.forEach((categoria) => {
        if (categoria.listagem && categoria.listagem.length) {
          for (var i = 0; i < categoria.listagem.length; i++)
            if (!data || categoria.listagem[i].id == data.idDocumento)
              if (
                categoria.listagem[i].obrigatorio &&
                (!categoria.listagem[i].arquivos ||
                  !categoria.listagem[i].arquivos.length)
              ) {
                this.$set(categoria.listagem[i], "hasError", true);
              } else {
                this.$set(categoria.listagem[i], "hasError", false);
              }
        }
      });

      this.$forceUpdate();
      this.$emit("send", this.pendencias);
    },
  },
  mounted() {
    this.pendencias = this.documentosSolicitados
      ? JSON.parse(JSON.stringify(this.documentosSolicitados))
      : [];
  },
  created() {
    eventBus.$on("validaAnexos", this.validaAnexos);
    eventBus.$on("setModelAnexos", this.setModelAnexos);
  },
};
</script>

<style lang="scss" scoped>
.categoria {
  font-size: 1.8vh;
  font-weight: 600;
  color: #061d45;
  margin-bottom: 0;
  margin-top: 2vh;
}

.inline {
  p {
    width: 100%;
  }

  i {
    padding-top: 1vh;
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AnexoListComponent.vue